import BaseService from "./BaseService";

export default class UserDetailsService extends BaseService {
    public static getUserDetails(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'user/v2', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static UpdateUserStatus(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'user/update-status/v2', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }


    public static getUserStatus(token: string, postData: any, userId: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}payment/user-status-history/${userId}`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getAllSupportStaffs(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'authorization/support-staff-list', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getAllAdmins(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'authorization/admin-list', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static UpdateSupportStaffStatus(token: string, userId: string, status: number) {
        return BaseService.sendRequest(
            `${process.env.REACT_APP_API_URL}/authorization/support-staff/update-user-status/${userId}/${status}`,
            {
                method: 'GET', // Correct casing for 'get'
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }
        );
    }

    public static updateUserDetails(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'user/update-user', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static validateEmailAndMobile(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'user/validate-email-and-mobile', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getUserPersonaIdDoc(token: string, persona_Id: string) {
        return BaseService.sendRequest(
            `${process.env.REACT_APP_API_URL}profile/get/persona-info/government-id/${persona_Id}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }
        );
    }

    public static getUserCardList(token: string, postData: any, userId: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}user/user-card-list/${userId}`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static updateCardStatus(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}user/update-user-card-status`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getUserBalance(userId: string, token: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}payment/wallet-transaction-history/admin/${userId}`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
    }
}